import React from "react";
import {Card} from "@mui/material";
import {useSelector} from "react-redux";
import CustomEmpty from "../custom-empty";
import PackageMetadataViewer, {PACKAGE_METADATA_TYPE_JSON} from "../package-metadata-viewer";
import {nodeSelector} from "../../state/node/nodeSelectors";

const Viewer = ({packageId, hasMetadata}) => {
  const node = useSelector(nodeSelector);

  const nodeId = node.nodeId;
  const nodeType = node.type;

  return (
    <Card
      sx={{
        width: "100%",
        height: "100%",
        padding: "16px",
        overflow: "auto"
      }}
    >
      {hasMetadata ? (
        <PackageMetadataViewer
          nodeId={nodeId}
          nodeType={nodeType}
          packageId={packageId}
          metadataType={PACKAGE_METADATA_TYPE_JSON}
        />
      ) : (
        <CustomEmpty />
      )}
    </Card>
  );
};

export default Viewer;
